import React, { useState } from 'react'
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import editprof from "../../assets/img/hosting/mockup (1) 1.png"
import { useUserInfo } from '../../context/UserContext';
import useFetch from '../../hooks/useAxios';
import Button from '../shared/Button'
const HostingCompleteProfile = () => {
  const [isProfileCompeleted, setisProfileCompeleted] = useState(); //city //start //end //count
  const isProfileCompletedFetch = useFetch({
    method: "get",
    url: "api/complete-profile",
    noHeader: false,
    trigger: true,
    argFunc: res => setisProfileCompeleted(res.data.is_complete)
  });
  const navigate = useNavigate()
  const changetohost = useFetch({
    method: "post",
    url: "api/guest/change-role",
    noHeader: false,
    trigger: false,
    argFunc: res => {
      if(!isProfileCompeleted){
        toast.error("برای میزبان شدن اول پروفایل خود را تکمیل کنید.")
        navigate("/user/editprofile")
      }else{
        navigate("/user")
       
        toast.success("شما میزبان شدید")
      }
    }
  });

 const handleOnClick = ()=>{
  
    changetohost.reFetch()
  }
  return (
    <div className='HostingCompleteProfile'>
       <div className='container'>
       <h3>تکمیل پروفایل</h3>
        <p>پیش از ثبت اقامتگاه در جاتیک و میزبانی در جاتیک الزامی ست که در وبسایت ثبت نام کنید ، سپس می بایست اطلاعات شناسایی خود را از قبیل تصویر کارت ملی ، نام و نام خانوادگی ،شماره ملی رو ثبت نمایید . در غیر این صورت  براساس خط مشی مشتریان جاتیک و وفاداری به آنها اقامتگاه شما در تمام صفحات وبسایت نمایش نخواهد شد .</p>
        <img src={editprof}/>
       </div>
       <div className='center my-[100px] '>
       <div className=' w-[300px]'>
         <Button varient="primary" onClick={handleOnClick} fullwidth={true}  >
           میزبان شو
         </Button>
       </div>
       </div>
    </div>
  )
}

export default HostingCompleteProfile